export default __webpack_public_path__ + "static/media/flag-ukraine.d6171bce.svg";